import {UserResponse} from '../users/userModel';
import {GroupGuest} from './groupModel';

export type SplitParticipant = UserResponse | GroupGuest;
/** Numeric IDs are retained only for legacy registered-user assignments. */
export type ParticipantKey = number | string;

export function isGuest(participant: SplitParticipant): participant is GroupGuest {
  return !('username' in participant);
}

export function canonicalParticipantKey(key: ParticipantKey): string {
  const value = typeof key === 'number' ? `user:${key}` : key;
  if (!/^(user|guest):[1-9]\d*$/.test(value) ||
      !Number.isSafeInteger(Number(value.split(':')[1]))) {
    throw new Error('Invalid participant key.');
  }
  return value;
}

export function participantKey(participant: SplitParticipant): string {
  return canonicalParticipantKey(`${isGuest(participant) ? 'guest' : 'user'}:${participant.id}`);
}

export function participantName(participant: SplitParticipant): string {
  return isGuest(participant) ? participant.name : participant.username;
}

export function participantKeys(keys: ParticipantKey[]): string[] {
  return Array.from(new Set(keys.map(canonicalParticipantKey)));
}
